<template>
  <header>
    <div class="container">
      <div class="left">
        <router-link class="logo" to="/" title="后台管理系统">
          <h2 class="title">
            后台管理系统
          </h2>
        </router-link>
        <el-radio-group
          @change="platformChange"
          v-model="platformCode"
          size="mini">
          <el-radio-button
            v-if="config.NODE_ENV === 'development'"
            label="JingsuanAI">
            测试环境
          </el-radio-button>
          <el-radio-button
            label="tangsengbao">
            唐僧保
          </el-radio-button>
          <el-radio-button
            label="wanqubaoxian">
            湾区保险
          </el-radio-button>
          <el-radio-button
            label="wanquPolicy">
            湾区保单管理
          </el-radio-button>
          <el-radio-button
            label="tsbyanxuan">
            唐僧保严选
          </el-radio-button>
          <el-radio-button
            label="ProtectionAngel">
            ProtectionAngel
          </el-radio-button>
        </el-radio-group>
      </div>
      <div class="user">
        欢迎您！
        <el-dropdown trigger="click">
          <span class="el-dropdown-link">
            {{ userName }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <!-- <el-dropdown-item><span>修改密码</span></el-dropdown-item> -->
            <el-dropdown-item>
              <span @click="logout()">退出</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <!-- <div class="login" v-if="admin === ''">
        <el-button type="primary" @click="showLogin">登录</el-button>
      </div> -->
    </div>
  </header>
</template>

<script>
import config from '@/lib/config';
import { getLocalStorage, setLocalStorage } from '../../utils/utils';

export default {
  name: 'TopBar',
  data() {
    return {
      config,
      platformCode: '',
    };
  },
  props: {
    userName: {
      type: String,
    },
  },
  created() {
    if (getLocalStorage('platformCode') === null || getLocalStorage('platformCode') === '') {
      if (config.NODE_ENV === 'development') {
        this.platformCode = 'JingsuanAI';
      } else {
        this.platformCode = 'tangsengbao';
      }
    } else {
      this.platformCode = getLocalStorage('platformCode');
    }
    setLocalStorage('platformCode', this.platformCode);
  },
  methods: {
    logout() {
      const data = {
        SessionId: getLocalStorage('sessionId'),
      };
      this.$http.post('/admin/logout', data).then((res) => {
        if (res.Code === this.$requestCode.RESPONSE_SUCCESS.code) {
          setLocalStorage('sessionId', '');
          setLocalStorage('userName', '');
          this.$bus.$emit('logout');
        } else {
          this.$requestStatus(res);
        }
      });
    },
    platformChange() {
      setLocalStorage('platformCode', this.platformCode);
      location.reload(false);
    },
  },
};
</script>

<style lang="scss" scoped>
  .topBar-box {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    width: 100%;
    height: 50px;
    color: #fff;
    header {
      min-width: 1200px;
      .container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        // position: fixed;
        width: 100%;
        min-width: 1200px;
        height: 50px;
        line-height: 50px;
        padding: 0 20px;
        background-color: #409EFF;
        box-sizing: border-box;
        overflow-x: auto;
        // box-shadow: 0 0 10px 0 rgba(141,175,247,0.36);
        .left {
          display: flex;
          align-items: center;
        }
        .logo {
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 12px;
          color: #fff;
          margin-right: 40px;
          h2 {
            padding-left: 20px;
            font-weight: normal;
          }
        }
        .user {
          color: #fff;
          .el-dropdown-link {
            cursor: pointer;
            color: #fff;
          }
          .logout {
            margin-left: 20px;
            color: #fff;
            cursor: pointer;
            &:hover {
              text-decoration: underline;
            }
          }
        }
        .login {
          .el-button {
            border: 1px solid #fff;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/TopBar.vue